import React from "react";
import PropTypes from "prop-types";
import * as S from "./Card.styled";

export const CardHeader = (props) => <S.StyledCardHeader {...props} />;
export const CardBody = (props) => <S.StyledCardBody {...props} />;
export const CardFooter = (props) => <S.StyledCardFooter {...props} />;
export const CardContainer = (props) => <S.StyledCard {...props} />;

const Card = (props) => {
  const { header, children, footer, className } = props;

  return (
    <CardContainer {...props} className={`Card ${className}`}>
      {header ? (
        <CardHeader className="Card__Header">{header}</CardHeader>
      ) : null}
      <CardBody className="Card__Body">{children}</CardBody>
      {footer ? (
        <CardFooter className="Card__Footer">{footer}</CardFooter>
      ) : null}
    </CardContainer>
  );
};

Card.defaultProps = {
  header: null,
  footer: null,
};

Card.propTypes = {
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  footer: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default Card;
